import React from 'react'
import { ComingSoon } from '@/components/common/ComingSoon'

const InventoryPage = () => {
  return (
    <ComingSoon 
      title="Inventory Management"
      description="Parts, equipment, and warehouse management"
    />
  )
}

export default InventoryPage
